export const socialsData = {
    github: 'https://github.com/Akshay-06',
    facebook: 'https://www.facebook.com/akshay.reddy.108/',
    linkedIn: 'https://www.linkedin.com/in/akshay-06/',
    instagram: 'https://www.instagram.com/chintu_06',
    twitter: 'https://twitter.com/AkshayR27310097',
    youtube: 'https://www.youtube.com/@akshayreddy9258',
    leetcode:'https://leetcode.com/u/Akshay_06/',
    hackerrank: 'https://www.hackerrank.com/profile/S30903'
}